import { Box, Grid, Paper, Tabs, Tab, useTheme } from "@mui/material";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function IPDNav() {
  const { t } = useTranslation();
  const [value, setValue] = useState("/ipd");
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  useEffect(() => {
    const path = location.pathname;
    const validPaths = [
      "/ipd",
      "/ipd/admissions",
      "/ipd/admissions/new",
      "/ipd/ward-rounds",
      "/ipd/medical-equipment",
    ];
    if (validPaths.includes(path)) {
      setValue(path);
    } else {
      setValue("/ipd");
    }
  }, [location.pathname]);

  return (
    <Grid container maxWidth="xl">
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            sx={{
              ml: "5px",
              "& .MuiTabs-indicator": { display: "none" },
            }}
          >
            {[
              { path: "/ipd", label: t("ipd.nav.dashboard", "Dashboard") },
              {
                path: "/ipd/admissions",
                label: t("ipd.nav.admissions", "Admissions"),
              },
              {
                path: "/ipd/admissions/new",
                label: t("ipd.nav.new_admission", "New Admission"),
              },
              {
                path: "/ipd/ward-rounds",
                label: t("ipd.nav.ward_rounds", "Ward Rounds"),
              },
              {
                path: "/ipd/medical-equipment",
                label: t("ipd.nav.medical_equipment", "Medical Equipment"),
              },
            ].map((tab, index) => (
              <Tab
                key={index}
                style={{
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  borderRadius: "10px",
                  backgroundColor:
                    value === tab.path ? theme.palette.primary.main : "white",
                  color: value === tab.path ? "white" : "black",
                }}
                label={tab.label}
                value={tab.path}
                component={NavLink}
                to={tab.path}
              />
            ))}
          </Tabs>
        </Paper>
        <Box sx={{ p: 1 }}>
          <Outlet />
        </Box>
      </Box>
    </Grid>
  );
}
